import React, { useEffect, useRef, useState } from "react";
import { useParams } from "react-router-dom";
import "../App.css";

export default function HelpFAQPage() {
  const { id } = useParams();
  const [searchQuery, setSearchQuery] = useState("");
  const [openIndex, setOpenIndex] = useState(null);
  const faqRefs = useRef([]);

  const faqs = [
    {
      question: "Apa itu MySite?",
      answer:
        "MySite adalah platform untuk membuat dan meng-hosting website secara mudah dan cepat. Anda hanya perlu mengisi informasi yang dibutuhkan dan langsung mempublikasikan tanpa perlu keahlian teknis."
    },
    {
      question: "Bagaimana cara membuat website?",
      answer:
        "Masuk ke Dashboard, pilih 'Buat Website', kemudian pilih paket. Setelah itu, isi konten (teks, gambar, CTA), dan website akan langsung aktif. Anda dapat mengubah konten kapan saja."
    },
    {
      question: "Apakah saya bisa menggunakan domain kustom (mis. namaperusahaan.com)?",
      answer:
        "Fitur ini masih dalam tahap pengembangan, semua pengguna akan mendapatkan pemberitahuan saat fitur ini telah tersedia."
    },
    {
      question: "Bagaimana struktur paket dan pembayaran?",
      answer:
        "MySite menggunakan paket berlangganan berdasarkan durasi. Pembayaran diproses dalam IDR melalui mitra pembayaran resmi kami. Harga dapat berubah dan akan diberlakukan pada periode berikutnya setelah pemberitahuan."
    },
    {
      question: "Apakah ada kebijakan pengembalian dana (refund)?",
      answer:
        "Biaya berlangganan dibayarkan di muka dan tidak dapat dikembalikan, kecuali diwajibkan oleh hukum yang berlaku. Pastikan Anda meninjau paket sebelum melakukan pembayaran."
    },
    {
      question: "Apakah ada batasan ukuran file gambar atau aset?",
      answer:
        "Untuk performa optimal, kami menyarankan gambar di bawah 1 MB per file. Format umum seperti JPG, PNG, dan WEBP didukung. Batasi resolusi sesuai kebutuhan agar halaman tetap cepat."
    },
    {
      question: "Bagaimana cara mengubah isi website?",
      answer:
        "Buka website Anda dari Dashboard, lalu ubah informasi yang diinginkan. Website mungkin membutuhkan waktu beberapa menit untuk menyesuaikan perubahan(Terdapat sistem caching untuk meningkatkan performa setiap website)."
    },
    {
      question: "Apakah MySite mendukung SEO dasar?",
      answer:
        "Ya. SEO dasar telah didukung dengan melengkapi informasi website yang diperlukan seperti nama merek, judul, deskripsi. Semua website yang dibuat di MySite akan masuk ke dalam sitemap MySite, sehingga setiap website yang dibuat dapat diindex oleh Google."
    },
    {
      question: "Bagaimana status uptime dan performa hosting?",
      answer:
        "Kami berupaya menjaga uptime yang tinggi dan performa stabil. Namun, pemeliharaan terjadwal atau gangguan jaringan dapat terjadi. Anda dapat mengaktifkan cache dan optimasi gambar untuk hasil lebih cepat."
    },
    {
      question: "Bagaimana cara memperpanjang berlangganan?",
      answer:
        "Buka website yang ingin diperpanjang, klik 'Perpanjang', pilih paket, lalu selesaikan pembayaran. Masa aktif akan diperbarui otomatis setelah pembayaran berhasil."
    },
    {
      question: "Bagaimana cara menghubungi dukungan (support)?",
      answer:
        "Silakan hubungi kami melalui email di support@mysite.co.id. Kami biasanya merespons dalam 1–3 hari kerja."
    }
  ];

  useEffect(() => {
    if (id && !isNaN(id)) {
      const index = parseInt(id, 10) - 1;
      if (index >= 0 && index < faqs.length) {
        setOpenIndex(index);
        setTimeout(() => {
          faqRefs.current[index]?.scrollIntoView({ behavior: "smooth", block: "center" });
        }, 300);
      }
    }
  }, [id, faqs.length]);

  const filteredFaqs = faqs.filter(
    (faq) =>
      faq.question.toLowerCase().includes(searchQuery.toLowerCase()) ||
      faq.answer.toLowerCase().includes(searchQuery.toLowerCase())
  );

  return (
    <div style={{ padding: "20px" }}>
      <h1 style={{ fontSize: "1.8rem", marginBottom: "10px", color: "#1f2937" }}>
        Pusat Bantuan & FAQ
      </h1>
      <p style={{ fontSize: "1rem", marginBottom: "20px", color: "#4b5563" }}>
        Temukan jawaban pertanyaan umum tentang membuat website di MySite.
      </p>

      {/* Pencarian */}
      <input
        type="text"
        placeholder="Cari FAQ…"
        value={searchQuery}
        onChange={(e) => setSearchQuery(e.target.value)}
        style={searchInputStyle}
        aria-label="Cari FAQ"
      />

      <div style={{ marginTop: "20px", ...faqContainer }}>
        {filteredFaqs.length > 0 ? (
          filteredFaqs.map((faq, index) => (
            <div
              key={index}
              ref={(el) => (faqRefs.current[index] = el)}
              style={{
                ...faqItemStyle,
                border: openIndex === index ? "2px solid #2563eb" : "1px solid #ddd",
              }}
            >
              <div
                style={faqQuestionStyle}
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
                role="button"
                tabIndex={0}
                onKeyDown={(e) => (e.key === "Enter" || e.key === " ") && setOpenIndex(openIndex === index ? null : index)}
                aria-expanded={openIndex === index ? "true" : "false"}
              >
                <span>{faq.question}</span>
                <span>{openIndex === index ? "−" : "+"}</span>
              </div>
              {openIndex === index && (
                <div style={faqAnswerStyle}>
                  <p>{faq.answer}</p>
                </div>
              )}
            </div>
          ))
        ) : (
          <p style={{ color: "#6b7280", fontSize: "0.95rem" }}>
            Tidak ada hasil untuk “{searchQuery}”.
          </p>
        )}
      </div>
    </div>
  );
}

/* --- Styles --- */
const faqContainer = {
  display: "flex",
  flexDirection: "column",
  gap: "10px",
};

const faqItemStyle = {
  backgroundColor: "#fff",
  borderRadius: "6px",
  padding: "15px",
  cursor: "pointer",
  boxShadow: "0 2px 6px rgba(0, 0, 0, 0.05)",
  transition: "border 0.2s ease",
};

const faqQuestionStyle = {
  display: "flex",
  justifyContent: "space-between",
  fontWeight: "600",
  fontSize: "1rem",
  color: "#1f2937",
};

const faqAnswerStyle = {
  marginTop: "10px",
  fontSize: "0.95rem",
  color: "#4b5563",
};

const searchInputStyle = {
  width: "100%",
  padding: "10px",
  border: "1px solid #ccc",
  borderRadius: "6px",
  fontSize: "1rem",
};
